import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, canonicalUrl, noindex = false }) => {
  const baseUrl = 'https://www.futeur.ai';
  const fullUrl = `${baseUrl}${canonicalUrl}`;

  return (
    <Helmet>
      <title>{title ? `${title} | Futeur AI` : 'Futeur AI'}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={fullUrl} />
      {noindex && <meta name="robots" content="noindex,follow" />}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
};

export default SEO;
